import { render } from "./GoBackIcon.vue?vue&type=template&id=102eaa54&scoped=true&ts=true"
import script from "./GoBackIcon.vue?vue&type=script&lang=ts"
export * from "./GoBackIcon.vue?vue&type=script&lang=ts"

import "./GoBackIcon.vue?vue&type=style&index=0&id=102eaa54&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102eaa54"]])

export default __exports__